import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";
import { inventoryItemFilterInput } from "../inventory-item-filters";

export const getInventoryItemsForExport = unaryRpc({
  name: "getInventoryItemsForExport" as const,
  input: inventoryItemFilterInput,
  output: z.object({
    csv: z.string(),
    filename: z.string(),
    truncated: z.boolean(),
  }),
});
